import { InjectionToken } from '@angular/core';

import { TppIdentityManagementAccess } from './tpp-identity-management-access';

export const TPP_IDENTITY_MANAGEMENT = new InjectionToken<
  TppIdentityManagementAccess
>('TppIndentityManagementAccess');
